<template>
  <modal name="DraftEventModal" :width="'75%'" :height="'auto'"
        :scrollable="true" :pivotX="1.0" :minWidth="900" @before-open="beforeOpen" @before-close="beforeClose"
        >
    <div class="draft-events-modal" @click="onSaveDraft">
      <div class="header-modal">
        <div class="container-title">
          <p class="draft-event">Draft Event</p>
          <div class="add-on-wrapper">
            <div class="event-add-on">
              <input type="checkbox" v-model="currentEvent.isLive" id="is-live" @change="updateIsLiveEvent('LIVE')"/>
              <label for="is-live">Toggle</label>
            </div>
            <p :class="{'text-toggle-on': currentEvent.isLive }">Live</p>
          </div>
        </div>
        <div class="modal-close" @click="hideModal">
          <div class="icon-close"></div>
        </div>  
      </div>
      <p class="text-title">Event Information</p>
      <div class="row">
        <div class="col-md-3 field-input">
          <label>Event Name</label>
          <input placeholder="State - City #" v-model="currentEvent.eventName"/>
        </div>
        <div class="col-md-3 field-input">
          <label>Date<span class="require-askterisk">*</span></label>
          <date-picker :format="'MM/dd/yyyy'" placeholder="MM/DD/YY" :value="currentEvent.prefDate" @selected="onChangeDate"></date-picker>
        </div>
        <div class="col-md-3 field-input">
          <label>Leads<span class="require-askterisk">*</span></label>
          <input placeholder="# of leads" v-model="currentEvent.maxStaffLead"/>
          <div v-if="currentEvent.maxStaffLead <= 0" class="row log-error">
            <div class="col-sm-1 icon-alert">
              <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
            </div>
            <div class="col-sm-11 text-alert">
              <span class="alert-note">The number of leads must be greater than 0</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 field-input">
          <label>Participation<span class="require-askterisk">*</span></label>
          <input placeholder="# of expected participants" v-model="currentEvent.projPart"/>
          <div v-if="currentEvent.projPart <= 0" class="row log-error">
            <div class="col-sm-1 icon-alert">
              <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
            </div>
            <div class="col-sm-11 text-alert">
              <span class="alert-note">The number of participants must be greater than 0</span>
            </div>
          </div>
        </div>
      </div>
      <p class="text-title">Address</p>
      <div class="row">
        <div class="col-md-6 field-input">
          <label>Full Address<span class="require-askterisk">*</span></label>
          <vue-google-autocomplete 
            name="address-input"
            id="map_address"
            :country="['us']"
            :item="currentEvent"
            v-on:placechanged="setPlace"
            placeholder="Enter full address"
            :class="{'border-error': isAddressError }"
           ></vue-google-autocomplete>
          <span v-if="isAddressError" class="text-error">{{addressErrorMessage}}</span>
        </div>
        <div class="col-md-3 field-input">
          <label>Building/Suite</label>
          <input placeholder="Enter building name" v-model="currentEvent.building"/>
        </div>
        <div class="col-md-3 field-input">
          <label>Location</label>
          <input placeholder="Enter event room" v-model="currentEvent.eventLocation"/>
        </div>
      </div>
      <p class="text-title">Times</p>
      <div class="row">
        <div class="col-md-3 field-input">
          <label>Start Time<span class="require-askterisk">*</span></label>
          <select v-model="currentEvent.startTime" @change="onChangTime">
            <option v-for="time in listTime" :key="time.name" :value="time.name">{{time.name}}</option>
          </select>
        </div>
        <div class="col-md-3 field-input">
          <label>Duration<span class="require-askterisk">*</span></label>
          <input placeholder="Enter duration" v-model="currentEvent.duration" @blur="onChangTime"/>
          <div v-if="enableIconDuration" class="row log-error">
            <div class="col-sm-1 icon-alert">
              <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
            </div>
            <div class="col-sm-11 text-alert">
              <span class="alert-note">Standard events can only be submitted with durations between 0 - 10 hours. To request an event outside of this range please contact ADURO.</span>
            </div>
          </div>
        </div>
        <div class="col-md-3 field-input">
          <label>End Time</label>
          <p>{{currentEvent.endTime}}</p>
        </div>
         <div class="col-md-3 field-input">
          <label>Time Zone</label>
          <p>{{currentEvent.timeZone}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 field-input">
          <label>Aduro Arrival Time<span class="require-askterisk">*</span></label>
          <select v-model="currentEvent.aduroArrivalTime">
            <option v-for="time in listTime" :key="time.name" :value="time.name">{{time.name}}</option>
          </select>
        </div>
      </div>
      <p class="text-title">On Site Contact</p>
      <div class="row">
        <div class="col-md-3 field-input">
          <label>Name<span class="require-askterisk">*</span></label>
        <on-site-contact-search
          :initial-text="currentEvent.contactName"
          :on-site-contacts="onSiteContacts"
          :placeholder="'Enter full name'"
          :identity="'draft-onsite-contact'"
          @search="searchContact"
          class="field-contact"
          @itemselected="selectOnSiteContact" 
        >

        </on-site-contact-search>
        </div>
        <div class="col-md-6 field-input">
          <label>Email<span class="require-askterisk">*</span></label>
          <input placeholder="Enter email" v-model="currentEvent.email"/>
        </div>
        <div class="col-md-3 field-input">
          <label>Phone Number<span class="require-askterisk">*</span></label>
          <input placeholder="Enter phone number" v-model="currentEvent.phone"/>
        </div>
      </div>
      <p class="text-title">Add On Services</p>
      <div class="row">
        <div class="col-md-3 add-on-wrapper" v-for="(item, index) in currentEvent.additionalServices.slice(0, 3)" :key="index" v-if="item.isShow">
          <div class="event-add-on">
            <input type="checkbox" 
              @change="checkboxToggle(item.key, item.value)" 
              :id="item.key"
              v-model="item.value"
              :class="disableAdditionalServices(item.key) ? 'greyOut' : null"
              :disabled="disableAdditionalServices(item.key)"
              />
            <label :for="item.key">Toggle</label>
          </div>
          <p :class="{'text-toggle-on': item.value, 'greyOut': disableAdditionalServices(item.key)}">{{item.text}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 add-on-wrapper" v-for="(item, index) in currentEvent.additionalServices.slice(3, 7)" :key="index" v-if="item.isShow">
          <div class="event-add-on">
            <input type="checkbox" @change="checkboxToggle(item.key, item.value)" :id="item.key" v-model="item.value"/>
            <label :for="item.key">Toggle</label>
          </div>
          <p :class="{'text-toggle-on': item.value }">{{item.text}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 add-on-wrapper" v-for="(item, index) in currentEvent.additionalServices.slice(7, 10)" :key="index" v-if="item.isShow">
          <div class="event-add-on">
            <input type="checkbox" @change="checkboxToggle(item.key, item.value)" :id="item.key" v-model="item.value"/>
            <label :for="item.key">Toggle</label>
          </div>
          <p :class="{'text-toggle-on': item.value }">{{item.text}}</p>
        </div>
      </div>
      <p class="text-title">Event Notes</p>
      <div class="row">
        <div class="col-md-6 field-input">
          <label>Shipping Address - Enter if different than event address</label>
          <input placeholder="Enter shipping address" v-model="currentEvent.shippingAddress"/>
        </div>
        <div class="col-md-6 field-input">
          <label>Custom Event Notes</label>
          <input placeholder="Enter event notes" v-model="currentEvent.customEventNote"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 field-input">
          <label>On Site Instructions</label>
          <input placeholder="Enter On Site Instructions" v-model="currentEvent.onsiteInstruction"/>
        </div>
        <div class="col-md-6 field-input">
          <label>Parking Instructions</label>
          <input placeholder="Enter Parking Instructions" v-model="currentEvent.parkingInformation"/>
        </div>
      </div>
      <div class="btn-container">
        <b-button class="btn-cancel" @click="hideModal">
          Cancel
        </b-button>
        <div class="btn-right-container">
          <b-button class="btn-submit" :disabled="enableBtnSave" @click="onSubmit">
            Submit
          </b-button>
          <b-button class="btn-save" :disabled="enableBtnSave" @click="onSave">
            <b-spinner v-if="loadingSaveDraft"></b-spinner>
            Save as Draft
          </b-button>
        </div>
        <ModalSubmitDrafts
          :currentEvent="currentEvent"
        ></ModalSubmitDrafts>
      </div>
    </div>
  </modal>
</template>

<script>
  import 'vue-awesome/icons/exclamation-circle';
  import 'vue-awesome/icons/arrow-circle-o-right';
  import 'vue-awesome/icons/chevron-right';
  import 'vue-awesome/icons/chevron-down';
  import 'vue-awesome/icons/floppy-o';
  import 'vue-awesome/icons/trash-o';
  import 'vue-awesome/icons/repeat';
  import 'vue-awesome/icons/exchange';
  import 'vue-awesome/icons/angle-right';
  import 'vue-awesome/icons/refresh';
  import 'vue-awesome/icons/question-circle';
  import 'vue-awesome/icons/files-o';
  import Icon from 'vue-awesome/components/Icon';
  import DatePicker from 'vuejs-datepicker';
  import VueGoogleAutocomplete from 'vue-google-autocomplete';
  import Vue from 'vue';
  import consts from '../../_consts';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import moment from 'moment';
  import 'vue-awesome/icons/search';
  import Multiselect from 'vue-multiselect';
  import ModalSubmitDrafts from '../../components/modal/ModalSubmitDrafts';
  import * as _ from 'lodash';
  import OnSiteContactSearch from '../../components/events/OnSiteContactSearch.vue'
  export default {
    name: 'DraftEventModal',
    components: {
      Icon,
      DatePicker,
      VueGoogleAutocomplete,
      Vue,
      Multiselect,
      ModalSubmitDrafts,
      OnSiteContactSearch
    },
    data () {
      return {
        listTime: consts.listTime,
        isAddressError: false,
        eventFields: consts.fields.event,
        loadingSaveDraft: false
      }
    },
    methods: {
      beforeOpen (params) {
        let event = params.params || this.currentEvent;
        if (params.params != null) {
          this.currentEvent = Object.assign(this.currentEvent, event);
        }
        let newAdditionalServices = _.cloneDeep(consts.addOns);
        let strAddOns = localStorage.getItem(consts.LOCAL_STORE.addOns);
        let arrAddOns = strAddOns.split(',');
        let arrOnOff = event.addOns === null ? [] : event.addOns.split(',');
        newAdditionalServices.forEach(service => { service.value = false; service.isShow = false });
        newAdditionalServices.forEach(service => {
          arrAddOns.forEach(ele => {
            if (ele === service.key) {
              service.isShow = ele === consts.listAdditionalServicesKey.smallSiteModel ? event.projPart < 34 : true;
            }
          });
          arrOnOff.forEach(ele => {
            if (ele === service.key) {
              service.value = true;
              if (ele === consts.listAdditionalServicesKey.smallSiteModel) {
                event.disableDuration = event.projPart < 34;
              }
            }
          })
        });
        this.currentEvent.additionalServices = newAdditionalServices;
      },
      beforeClose () {
        this.createNewEventClick();
      },
      hideModal () {
        this.$modal.hide('DraftEventModal');
      },
      onChangTime () {
        if (this.currentEvent.duration === 0 || !this.currentEvent.startTime) return;
        this.currentEvent.endTime = moment(this.currentEvent.startTime, 'h:mm A').add(this.currentEvent.duration, 'hours').format('h:mm A');
      },
      setPlace (data, place) {
        this.resetFullAddress();
        this.currentEvent.fullAddress = place.formatted_address;

        let res = place && place.formatted_address.split(',');
        let resAdr = '';
        if (res.length > 3) {
          let temp = _.trim(res[res.length - 2]).split(' ');
          resAdr = temp[0] + '-' + res[res.length - 3];
        }
        this.currentEvent.eventName = resAdr;

        let addressComponents = place.address_components;
        for (let i = 0; i < addressComponents.length; i++) {
          let component = addressComponents[i];
          if (component.types.indexOf('sublocality_level_1') >= 0 || component.types.indexOf('sublocality') >= 0 || component.types.indexOf('locality') >= 0) {
            this.currentEvent.city = component.long_name;
          }
          if (component.types[0] === 'administrative_area_level_1') {
            this.currentEvent.state = component.short_name;
          }
          if (component.types[0] === 'postal_code') {
            this.currentEvent.zipCode = component.short_name;
          }
        }

        this.currentEvent.latitude = place.geometry.location.lat() || 0;
        this.currentEvent.longitude = place.geometry.location.lng() || 0;

        let req = Vue.axios.create();
        req.get(consts.googleApisMaps, {
          params: {
            location: `${place.geometry.location.lat()},${place.geometry.location.lng()}`,
            timestamp: `${Math.round((new Date().getTime()) / 1000)}`,
            key: this.googleMapApiKey === '' ? localStorage.getItem(consts.LOCAL_STORE.googleAPIKey) : this.googleMapApiKey
          }
        }).then((response) => {
          if (response.data) {
            this.currentEvent.timeZone = this.getTimeZone(response.data.timeZoneName);
            this.currentEvent.timeZoneId = response.data.timeZoneId;
            this.isAddressError = this.isAddressReadyToUpdate();
          } else {
            this.$toast.error('Error calling Google Maps API', '', {
              ...this.$toastOpt.optInfo
            });
          }
        });
      },
      getTimeZone (tzString) {
        if (tzString.length === 0) {
          return '';
        }
        let str = '';
        let index = 0;
        while (index >= 0) {
          str += tzString.substr(0, 1);
          index = tzString.indexOf(' ');
          tzString = tzString.substring(index + 1);
        }
        return str;
      },
      checkboxToggle (key, value) {
        let obj = {
          clientId: this.currentEvent.clientId,
          eventId: this.currentEvent.id,
          key: key,
          isAdd: value,
          index: this.currentEvent.index
        };
        if (this.currentEvent.id !== 0) {
          this.updateEventAddOns(obj).then((response) => {
            this.currentEvent.addOns = response.data.addOns;
            this.$toastr('info', 'Update event successful', '');
            if (key === consts.listAdditionalServicesKey.smallSiteModel) {
              this.calculateDuration();
              this.onUpdateEvent(this.currentEvent);
            }
            if (key === consts.listAdditionalServicesKey.cotinine) {
              this.updateEventAddOns({
                eventId: this.currentEvent.id,
                key: consts.listAdditionalServicesKey.tobaccoSelfAttestation,
                isAdd: false,
                index: this.currentEvent.index
              }).then(() => {
                this.triggerSavingAddonForEvent();
              });
            }
            if (key === consts.listAdditionalServicesKey.tobaccoSelfAttestation) {
              this.updateEventAddOns({
                eventId: this.currentEvent.id,
                key: consts.listAdditionalServicesKey.cotinine,
                isAdd: false,
                index: this.currentEvent.index
              }).then(() => {
                this.triggerSavingAddonForEvent();
              });
            }
            if (this.currentEvent.additionalServices.slice(7, 10).find(x => x.key === key)) {
              this.currentEvent.additionalServices.slice(7, 10).forEach(element => {
                if (key !== element.key) {
                  element.value = false;
                }
              });
            }
          });
        } else {
          this.currentEvent.addOns = this.currentEvent.additionalServices.filter(e => e.value === true)
            .map(e => e.key)
            .join(',');
          this.onUpdateEvent(this.currentEvent);
        }
      },
      preventSave (event) {
        let classes = ['cell', 'day', 'selected', 'prev', 'up', 'next', 'blank', 'btn-submit', 'btn-cancel', 'icon-close', 'btn-save'];
        if (classes.find(e => event.target.classList.contains(e))) {
          return true;
        }
        let types = ['input', 'button', 'textarea', 'select', 'label', 'span'];
        return types.includes(event.target.tagName.toLowerCase());
      },
      onSaveDraft (e) {
        if (this.preventSave(e)) return;
        this.onUpdateEvent(this.currentEvent);
      },
      onSave () {
        this.loadingSaveDraft = true;
        this.onUpdateEvent(this.currentEvent);
      },
      onSubmit () {
        this.$modal.show('ModalSubmitDrafts', this.currentEvent);
      },
      isAddressReadyToUpdate () {
        return _.isEmpty(this.currentEvent.latitude && this.currentEvent.longitude && this.currentEvent.city && this.currentEvent.state && this.currentEvent.zipCode && this.currentEvent.timeZoneId);
      },
      searchContact (keyword) {
        this.currentEvent.contactName = keyword;
        this.getListOnSiteContact(keyword.toLowerCase());
      },
      selectOnSiteContact (contact) {
        if (contact) {
          this.currentEvent.contact = {
            contactName: contact.contactName,
            contactPhone: contact.contactPhone,
            contactEmail: contact.contactEmail
          }
          this.currentEvent.contactName = contact.contactName;
          this.currentEvent.phone = contact.contactPhone;
          this.currentEvent.email = contact.contactEmail;
        }
      },
      resetFullAddress () {
        this.currentEvent.latitude = null;
        this.currentEvent.longitude = null;
        this.currentEvent.city = null;
        this.currentEvent.state = null;
        this.currentEvent.zipCode = null;
        this.currentEvent.timeZoneId = null;
      },
      onChangeDate (date) {
        this.currentEvent.prefDate = moment(date).format('MM/DD/YYYY');
      },
      calculateDuration () {
        let projPart = this.currentEvent.projPart;
        let services = this.findAdditionalSercives(consts.listAdditionalServicesKey.smallSiteModel);
        if (services !== null && services.value === true) {
          if (projPart < 9) {
            this.currentEvent.duration = 4;
          }
          if (projPart > 8 && projPart < 17) {
            this.currentEvent.duration = 5;
          }
          if (projPart > 16 && projPart < 25) {
            this.currentEvent.duration = 6;
          }
          if (projPart > 24 && projPart < 29) {
            this.currentEvent.duration = 7;
          }
          if (projPart > 28) {
            this.currentEvent.duration = 8;
          }
        } else {
          let userFilled = this.currentEvent.userManualFilled;
          if (userFilled.indexOf(this.eventFields.duration) === -1) {
            if (projPart > 0 && projPart <= 32) {
              this.currentEvent.duration = 4;
            }
            if (projPart > 32 && projPart < 100) {
              this.currentEvent.duration = 4;
            }
            if (projPart >= 100 && projPart <= 140) {
              this.currentEvent.duration = 5;
            }
            if (projPart > 140 && projPart < 170) {
              this.currentEvent.duration = 6;
            }
            if (projPart >= 170 && projPart < 200) {
              this.currentEvent.duration = 7;
            }
            if (projPart >= 200) {
              this.currentEvent.duration = 8;
            }
          }
        }
      },
      findAdditionalSercives (key) {
        let result = null;
        this.currentEvent.additionalServices.forEach(element => {
          if (element.key === key) {
            result = element;
          }
        });
        return result;
      },
      triggerSavingAddonForEvent () {
        this.currentEvent.customEventNote += '.';
        this.currentEvent.customEventNote = this.currentEvent.customEventNote.slice(0, -1);
      },
      onUpdateEvent (event) {
        this.updateEvent(event).then(() => {}).finally(() => {
          if (this.loadingSaveDraft) {
            this.$modal.hide('DraftEventModal');
          }
          this.loadingSaveDraft = false;
        });
      },
      disableAdditionalServices (key) {
        if (key === consts.listAdditionalServicesKey.cotinine) {
          return this.currentEvent.additionalServices[6].isShow && this.currentEvent.additionalServices[6].value; // check order in consts
        }
        if (key === consts.listAdditionalServicesKey.tobaccoSelfAttestation) {
          return this.currentEvent.additionalServices[2].isShow && this.currentEvent.additionalServices[2].value; // check order in consts
        }
        if (key === consts.listAdditionalServicesKey.smallSiteConcierge) {
          return this.currentEvent.additionalServices[5].isShow && !this.currentEvent.additionalServices[5].value; // check order in consts
        }
      },
      updateIsLiveEvent (type) {
        let isCheck = false;
        switch (type) {
          case 'LIVE':
            isCheck = this.currentEvent.isLive;
            break;
          case 'ONLINE_SCHEDULER':
            isCheck = this.currentEvent.isOnlineScheduler;
            break;
          default:
            break;
        }
        this.actionUpdateIsLiveEvent({
          eventId: this.currentEvent.id,
          isCheck: isCheck || false,
          onlineType: type
        }).then((response) => {
          if (response.message) {
            this.$toastr('error', response.message, '');
          } else {
            this.updateStateEvent(this.currentEvent);
            this.$toastr('success', 'Update event successful!', '');
          }
        });
      },
      ...mapActions({
        updateEvent: 'ACTION_UPDATE_EVENT',
        updateEventAddOns: 'ACTION_UPDATE_EVENT_ADD_ON',
        getListOnSiteContact: 'ACTION_GET_LIST_ON_SITE_CONTACT',
        createNewEventClick: 'ACTION_CREATE_NEW_EVENT',
        actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT'
      }),
      ...mapMutations({
        updateStateEvent: 'MUTATION_UPDATE_EVENT'
      })
    },
    computed: {
      arrayDuration () {
        let range = [];
        for (let i = 1; i <= 24; i += 0.5) {
          range.push(i);
        }
        return range;
      },
      enableBtnSave () {
        if (!this.currentEvent.prefDate || !this.currentEvent.maxStaffLead || this.currentEvent.maxStaffLead <= 0 || !this.currentEvent.projPart || this.currentEvent.projPart <= 0 || !this.currentEvent.fullAddress || !this.currentEvent.startTime || !this.currentEvent.duration || !this.currentEvent.contactName || !this.currentEvent.email || !this.currentEvent.phone || !this.currentEvent.aduroArrivalTime || this.isAddressError) return true;
        return false;
      },
      addressErrorMessage () {
        const generateAddress = [
          _.isEmpty(this.currentEvent.latitude) ? 'Number' : '',
          _.isEmpty(this.currentEvent.longitude) ? 'Street Name' : '',
          _.isEmpty(this.currentEvent.city) ? 'City' : '',
          _.isEmpty(this.currentEvent.state) ? 'State' : '',
          _.isEmpty(this.currentEvent.zipCode) ? 'ZipCode' : '',
          _.isEmpty(this.currentEvent.timeZoneId) ? 'TimeZoneId' : ''
        ];
        const message = generateAddress.filter(item => item !== '').join(', ');
        return `Require ${message}`;
      },
      onSiteContacts () {
        return this.listOnSiteContact;
      },
      enableIconDuration () {
        return this.currentEvent.duration <= 0 || this.currentEvent.duration > 10;
      },
      isCreateByEM () {
        let a = localStorage.getItem(consts.LOCAL_STORE.role) === consts.USER_ROLE.eventManager;
        let b = this.currentEvent.createdBy && this.currentEvent.createdBy.toString() === localStorage.getItem(consts.LOCAL_STORE.userId).toString();
        return a && b;
      },
      ...mapGetters({
        googleMapApiKey: 'GETTERS_GOOGLE_API_KEY',
        listOnSiteContact: 'GETTERS_LIST_ON_SITE_CONTACT',
        currentEvent: 'GETTER_CURRENT_EVENT'
      })
    },
    created () {
      this.createNewEventClick();
    },
    watch: {
      'currentEvent.projPart': {
        handler: function () {
          let strAddOns = localStorage.getItem(consts.LOCAL_STORE.addOns);
          let arrAddOns = strAddOns.split(',');
          this.currentEvent.additionalServices.forEach(service => {
            arrAddOns.forEach(ele => {
              if (ele === service.key) {
                service.isShow = ele === consts.listAdditionalServicesKey.smallSiteModel ? this.currentEvent.projPart < 34 : true;
              }
            });
          });
        }
      }
    }
};
</script>


// WEBPACK FOOTER //
// DraftEventModal.vue?2fcc5fa8